"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentProgressBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DpAssessmentProgressBar_styled_1 = require("./DpAssessmentProgressBar.styled");
var api_1 = require("../../../api");
var DpAssessmentProgressBar = function (_a) {
    var percentage = _a.percentage, points = _a.points, totalPoints = _a.totalPoints, type = _a.type;
    return ((0, jsx_runtime_1.jsx)(DpAssessmentProgressBar_styled_1.StyledAssessmentProgressBar, { type: type, width: percentage, "data-testid": "assessment-progress-bar", children: percentage > 0 && ((0, jsx_runtime_1.jsxs)("span", { className: "section", children: [(0, jsx_runtime_1.jsx)("span", { className: "points", children: "".concat((0, api_1.formatPoints)(points), "/").concat(totalPoints) }), "(".concat((0, api_1.formatPercentage)(percentage), "%)")] })) }));
};
exports.DpAssessmentProgressBar = DpAssessmentProgressBar;
exports.default = exports.DpAssessmentProgressBar;
